module.exports = ".card .card-header.card-image .card-title.overlay {\n  width: 100%;\n  left: 0;\n  text-indent: 20px;\n  height: 30px;\n  padding: 15px 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.35);\n  border-bottom: solid 20px rgba(0, 0, 0, 0.02);\n  position: absolute; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cards/image-card/image-card.component.scss
// module id = ./src/app/shared/components/cards/image-card/image-card.component.scss
// module chunks = main